import { useCallback, useEffect, useRef, useState } from 'react';
import { getPromemoriaScadenze } from '../../../../utils/api/promemoria_scadenze_api';

/**
 * The reminder configuration of the esercizio, shared by the toolbar button of
 * Documenti and the summary line under it.
 *
 * The read on mount fails silently on purpose: it only feeds the summary, and a
 * dialog popping up on every visit to Documenti would be louder than the feature
 * it belongs to. The button reads again with `leggi`, and that caller reports
 * the failure, at the moment the operator asked for the configuration.
 *
 * Only the latest read or save lands. A read on mount answering after the
 * button's own read, or after a save, would put back an older configuration.
 * A change of esercizio drops the configuration of the previous one at once.
 */
const usePromemoriaScadenze = (esercizioId) => {
  const [configurazione, setConfigurazione] = useState(null);
  const ultima = useRef(0);

  // Takes the turn of the latest write: the setter it returns does nothing once
  // a later read, save or change of esercizio has taken it.
  const prenota = useCallback(() => {
    ultima.current += 1;
    const mia = ultima.current;
    return (nuova) => {
      if (ultima.current === mia) {
        setConfigurazione(nuova);
      }
    };
  }, []);

  useEffect(() => {
    const imposta = prenota();
    imposta(null);
    getPromemoriaScadenze(esercizioId)
      .then(imposta)
      .catch(() => {});
    return () => {
      ultima.current += 1;
    };
  }, [esercizioId, prenota]);

  const leggi = useCallback(() => {
    const imposta = prenota();
    return getPromemoriaScadenze(esercizioId).then((letta) => {
      imposta(letta);
      return letta;
    });
  }, [esercizioId, prenota]);

  const aggiorna = useCallback((salvata) => prenota()(salvata), [prenota]);

  return { configurazione, leggi, aggiorna };
};

export default usePromemoriaScadenze;
